import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const ArrowDownIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/arrow-down"><path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M11.9999 3.6001C12.497 3.6001 12.8999 4.00304 12.8999 4.5001V17.2656L17.6512 12.2763C17.9957 11.918 18.5654 11.9068 18.9237 12.2513C19.282 12.5959 19.2932 13.1656 18.9487 13.5239L12.6487 20.1239C12.479 20.3004 12.2447 20.4001 11.9999 20.4001C11.7551 20.4001 11.5209 20.3004 11.3512 20.1239L5.05118 13.5239C4.70666 13.1656 4.71784 12.5959 5.07613 12.2513C5.43442 11.9068 6.00416 11.918 6.34868 12.2763L11.0999 17.2656L11.0999 4.5001C11.0999 4.00304 11.5029 3.6001 11.9999 3.6001Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ArrowDownIcon;